import apiClient from '@/services/axios'

export async function put(campaign) {
  var response = await apiClient.put('/ActivationPlanCampaigns/', campaign)
  if (response) {
    return response.data
  }

  throw new Error('Unable to update campaign.')
}